import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ percent }) => {
  return (
    <div
      style={{
        borderRadius: percent === 100 ? 4 : '4px 0px 0px 4px',
        backgroundColor: '#0F7B85',
        height: '100%',
        width: `${percent}%`,
      }}
    />
  );
};

ProgressBar.propTypes = {
  percent: PropTypes.number,
};

export default ProgressBar;
